/** Console — AC devices /device/conditioning (conditioning.vue) */
export default {
  deviceConditioning: {
    tabNavAria: 'AC module tabs',
    tabIndoor: 'Indoor units',
    tabOutdoor: 'Topology',

    phDeviceName: 'Device name',
    phTenant: 'Tenant name or ID',
    phOnlineStatus: 'Online status',
    phPowerStatus: 'Power status',
    all: 'All',
    online: 'Online',
    offline: 'Offline',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    sectionIndoorCard: 'Indoor unit cards',
    sectionIndoorList: 'Indoor unit list',
    batchAction: 'Batch',
    batchControl: 'Batch control',
    batchLock: 'Batch lock',
    batchUnlock: 'Batch unlock',
    batchTiming: 'Batch schedule',
    viewTimingTasks: 'Scheduled tasks',
    sortDefault: 'Default sort',
    viewList: 'List',
    viewCard: 'Cards',
    selectedCount: '{count} selected',
    copySerialTip: 'Click to copy',
    bindDedicated: 'Dedicated',
    bindPublic: 'Shared',
    colIndoorSerial: 'Serial no.',
    colDeviceName: 'Name',
    colDeviceType: 'Type',
    colBindShareType: 'Allocation',
    colBindInfo: 'Binding',
    colOutdoorSystemName: 'Outdoor system',
    colSwitch: 'Power',
    colMode: 'Mode',
    colTemp: 'Temp (°C)',
    colFanSpeed: 'Fan',
    colFault: 'Fault',
    colLastReportTime: 'Latest report time',
    colSerialShort: 'Serial',
    colId: 'Id',
    colOp: 'Actions',
    control: 'Control',
    unlock: 'Unlock',
    lock: 'Lock',
    dialogTip: 'Notice',
    dialogConfirm: 'OK',
    dialogCancel: 'Cancel',
    confirmUnlockSingle: 'Unlock this air conditioner?',
    confirmUnlockBatch: 'Unlock {count} air conditioners?',
    cardLockedHint: 'Locked',
    more: 'More',
    opTiming: 'Schedule',
    opEdit: 'Edit',
    opDetail: 'Details',
    opHistory: 'History',
    unbound: 'Unbound',
    faultNormal: 'OK',
    faultOffline: 'Offline',
    cardSerialLabel: 'Serial:',
    setTemp: 'Setpoint',
    indoorTemp: 'Room temp.',
    switchBtn: 'On/Off',
    modeBtn: 'Mode',
    fanBtn: 'Fan',

    outdoorPhSystem: 'Outdoor system',
    outdoorUnnamed: 'Unnamed',
    colGwMac: 'Gateway MAC',
    colOutdoorName: 'Outdoor system name',
    colTariffPlan: 'Tariff plan',
    colMeterDev: 'Metering',
    colIndoorUnits: 'Indoor units',
    priceSharp: 'Sharp rate',
    pricePeak: 'Peak rate',
    priceFlat: 'Shoulder rate',
    priceValley: 'Off-peak rate',
    view: 'View',
    bindElectricTariff: 'Bind tariff',

    relationTitle: 'Topology',
    nodeListTitle: 'Nodes',
    nodeListTitleWithParent: '{name} — nodes',
    phSearchNameSerial: 'Search name or serial',
    emptyNoData: 'No data',

    dialogEditDevice: 'Edit device',
    labelDeviceSerial: 'Serial no.',
    labelDeviceName: 'Name',
    labelDeviceType: 'Device type',
    labelShareType: 'Allocation type',
    labelRemark: 'Notes',
    phDeviceSerial: 'Serial number',
    phDeviceName: 'Device name',
    phSelectDeviceType: 'Select type',
    phSelectShareType: 'Select allocation',
    phRemark: 'Notes',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    saving: 'Saving…',

    ruleIndoorSerial: 'Serial is required',
    ruleDeviceName: 'Name is required',
    ruleDeviceType: 'Select a device type',
    ruleBindType: 'Select allocation type',

    currentProject: 'Current site',

    enumVrf: 'VRF',
    enumDedicated: 'Dedicated',
    enumPublic: 'Shared',
    enumPowerOff: 'Off',
    enumPowerOn: 'On',
    enumModeAuto: 'Auto',
    enumModeHeat: 'Heat',
    enumModeCool: 'Cool',
    enumModeFan: 'Fan',
    enumModeDry: 'Dry',
    enumFanAuto: 'Auto',
    enumFanLow: 'Low',
    enumFanMid: 'Med',
    enumFanHigh: 'High',
    enumLockNone: 'No lock',
    enumLockPowerOff: 'Force off',
    enumLockPowerOn: 'Force on',
    enumLogSwitch: 'Power',
    enumLogMode: 'Mode',
    enumLogLock: 'Lock',
    enumWeekMon: 'Mon',
    enumWeekTue: 'Tue',
    enumWeekWed: 'Wed',
    enumWeekThu: 'Thu',
    enumWeekFri: 'Fri',
    enumWeekSat: 'Sat',
    enumWeekSun: 'Sun',

    logUnlock: 'Unlock',
    tagAcPowerOn: 'On',
    tagAcPowerOff: 'Off',
    acDrawerTitle: 'Details',
    acDrawerLabelSerial: 'Serial no.',
    acDrawerLabelId: 'ID',
    acDrawerLabelType: 'Type',
    acDrawerLabelCreateTime: 'Created',
    acDrawerLabelDataUpdate: 'Last update',
    acDrawerLabelGateway: 'Gateway',
    acDrawerBindTitle: 'Binding',
    acDrawerNoBind: 'No binding information',
    acDrawerMeterTitle: 'Billing meters',
    acDrawerNoMeter: 'No meter linked',
    acDrawerMetricSetTemp: 'Setpoint (°C)',
    acDrawerMetricRoomTemp: 'Room temp. (°C)',
    acDrawerMetricMode: 'Mode',
    acDrawerMetricFan: 'Fan speed',
    acDrawerHistoryTitle: 'Control history',
    acDrawerViewTable: 'Table',
    acDrawerViewChart: 'Chart',
    acDrawerColTime: 'Time',
    acDrawerColSource: 'Source',
    acDrawerColType: 'Type',
    acDrawerColContent: 'Detail',
    acDrawerColResult: 'Result',
    acDrawerSourceDevice: 'Device report',
    acDrawerSourceUser: 'User command',
    acDrawerResultOk: 'OK',
    acDrawerResultFail: 'Failed',
    acDrawerEmptyHistory: 'No control history',
    acDrawerChartSeriesType: 'By type',
    acDrawerEnergyTitle: 'Energy usage',
    acDrawerEnergyReport: 'Open full report',
    acDrawerDateStart: 'Start date',
    acDrawerDateEnd: 'End date',
    acDrawerColDate: 'Date',
    acDrawerFanHigh: 'High fan',
    acDrawerFanMid: 'Med fan',
    acDrawerFanLow: 'Low fan',
    acDrawerFanAuto: 'Auto fan',
    acDrawerColDuration: 'Hours',
    acDrawerColKwh: 'kWh',
    acDrawerColTotalHours: 'Total h',
    acDrawerColTotalKwh: 'Total kWh',
    acDrawerColSysTotalKwh: 'System total kWh',
    acDrawerEmptyEnergy: 'No usage data',
    acDrawerTopologyTitle: 'Topology',
    acDrawerEmptyRelation: 'No related devices',
    acDrawerErrLoad: 'Failed to load',
    acDrawerWarnMeterSerial: 'Invalid meter serial',

    topoHint: 'Drag to pan · Scroll to zoom',
    topoRefresh: 'Refresh',
    topoVertical: 'Vertical',
    topoHorizontal: 'Horizontal',
    topoZoomOut: 'Zoom out',
    topoZoomIn: 'Zoom in',
    topoFocusRoot: 'Focus root',
    topoFocusSelected: 'Focus selection',
    topoResetView: 'Reset view',
    topoEmptyData: 'No topology data',
    treeSetTemp: 'Setpoint',
    treeRoomTemp: 'Room temp.',
    treeExpand: 'Expand',
    treeCollapse: 'Collapse',
    treeExpandN: 'Expand {n} nodes',
    treeAltNode: 'Node',

    warnNothingToCopy: 'Nothing to copy',
    successSerialCopied: 'Serial copied',
    errCopy: 'Copy failed',
    errOutdoorFetch: 'Failed to load outdoor systems',
    warnNoMeterForOutdoor: 'No meter linked to this outdoor unit',

    warnNoExportData: 'No data to export',
    warnNoSelectedExport: 'Please select rows to export',
    successExported: 'Exported {count} row(s)',
    successExportedLimit: '{total} row(s) in total, first {count} row(s) exported',
    errExport: 'Export failed',
    exporting: 'Exporting...',
    exportSheetName: 'Indoor units',
    exportFilePrefix: 'indoor-units'
  }
}
